import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from '../redux/store';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Home';
import Search from './Search';
import useTrackRouteChanges from '../hooks/useTrackRouteChanges';
import { useAppDispatch } from '../redux/hooks';
import { fetchUser, setUserData } from '../redux/slices/userSlice';
import { useUser } from '../hooks/useUser';
import Account from './Account';
import Logs from './Logs';
import Admin from './Admin';
import Users from './Users';
import Tags from './Tags';
import CardInput from './CardInput';

interface BusinessCardsProps {
  userKey: number;
  companyKey: number;
  companyApiKey: string;
}

interface BusinessCardsRoutesProps {
  userKey: number;
  userToken: string;
  companyKey: number;
  companyApiKey: string;
}

const BusinessCards: React.FC<BusinessCardsProps> = (props) => {
  const localCredentials = localStorage.getItem('userCredentials');
  const { userKey: localUserKey, userToken: localUserToken, companyKey: localCompanyKey } = localCredentials ? JSON.parse(localCredentials) : { userKey: null, userToken: null, companyKey: null };

  const userKey = props.userKey || localUserKey || null;
  const userToken = /*localUserToken || */ "7e16b5527c77ea58";
  const companyKey = props.companyKey || localCompanyKey || 2 || null;
  const companyApiKey = props.companyApiKey || "09df728269" || null;

  if (!companyApiKey) {
    return <div>Missing company API Key</div>;
  }

  return (
    <Provider store={store}>
      <BrowserRouter>
        <BusinessCardsRoutes userKey={userKey} userToken={userToken} companyKey={companyKey} companyApiKey={companyApiKey} />
      </BrowserRouter>
    </Provider>
  );
}

export default BusinessCards;

const BusinessCardsRoutes: React.FC<BusinessCardsRoutesProps> = ({ userKey: propUserKey, userToken: propUserToken, companyKey: propCompanyKey, companyApiKey: propCompanyApiKey }) => {
  useTrackRouteChanges();
  const dispatch = useAppDispatch();
  const { userKey: storedUserKey, userToken: storedUserToken, companyKey: storedCompanyKey /*loading: userLoading, error: userError*/ } = useUser();


  useEffect(() => {
    // Step 1: Ensure props contain userKey, userToken, and companyKey. Then set Credentials
    if (propUserKey && propUserToken && propCompanyKey) {
      dispatch(setUserData({ userKey: propUserKey, userToken: propUserToken, companyKey: propCompanyKey }));
    }
  }, [dispatch, propUserKey, propUserToken, propCompanyKey]);

  useEffect(() => {
    // Step 2: Fetch user data if storedUserKey and storedToken match props
    if (storedUserKey === propUserKey && storedUserToken === propUserToken && storedCompanyKey === propCompanyKey) {
      dispatch(fetchUser());
    }
  }, [dispatch, storedUserKey, storedUserToken, storedCompanyKey, propUserKey, propUserToken, propCompanyKey]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/camera/:cardKeyParam?" element={<CardInput />} />
      <Route path="/search" element={<Search />} />
      <Route path="/account" element={<Account />} />
      <Route path="/logs" element={<Logs />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/users" element={<Users />} />
      <Route path="/tags" element={<Tags />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}
